<p-badge
  [styleClass]=" hasData ?'containsInfo':'noInfocontains'"
  [pTooltip]="toolTip"
  tooltipPosition="top"
></p-badge>
